<script setup lang="ts">
const { client } = usePrismic();
const { locale, localeProperties } = useI18n();
const { alternateLanguages } = storeToRefs(usePageStore());

const { data: document, error } = await useAsyncData(
  `contact_page-${locale.value}`,
  async () => {
    const document = await client.getSingle("contact_page", {
      lang: localeProperties.value.language,
    });
    return document;
  },
);

if (error.value) {
  console.log("HERE", error.value);
  throw createError({ statusCode: 404, message: "Page not found" });
}

useHead(
  useFormattedHead({
    title:
      document.value?.data.meta_title ||
      document.value?.data.title.map((t) => t.text).join(" ") ||
      "",
    description:
      document.value?.data.meta_description ||
      document.value?.data.description.map((t) => t.text).join(" ") ||
      "",
  }),
);

onNuxtReady(() => {
  alternateLanguages.value = document.value?.alternate_languages || [];
});
</script>
<template>
  <PageContact v-if="document" :document="document" />
</template>
